import type { RootState } from '@/stores/store';
import type { AgentConfig } from '@/config/agent-config';

export const selectSelectedAgent = (state: RootState) => state.agent.selectedAgent;

// DB-backed catalogue selectors. The list replaces the old hardcoded
// AGENT_REGISTRY in agent-config.ts; loaded once at app boot via the
// useLoadAgents() hook.
export const selectAvailableAgents = (state: RootState): AgentConfig[] =>
  state.agent.availableAgents;
export const selectAgentsLoading = (state: RootState) => state.agent.agentsLoading;
export const selectAgentsLoaded = (state: RootState) => state.agent.agentsLoaded;
export const selectAgentsError = (state: RootState) => state.agent.agentsError;
export const selectAgentById =
  (id: string | null | undefined) =>
  (state: RootState): AgentConfig | null => {
    if (!id) return null;
    return state.agent.availableAgents.find((a) => a.id === id) ?? null;
  };
